import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

export default function WorkerPicker({ value, onChange }) {
  const [q, setQ] = useState("");
  const [opts, setOpts] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get(`/op/workers${q ? `?search=${encodeURIComponent(q)}` : ""}`).then((r) => setOpts(r.data.slice(0, 20))).catch(() => setOpts([]));
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="relative">
      <Label className="mb-1.5 block">ID / Nama Pengepul</Label>
      <Input
        value={value ? `${value.worker_id} · ${value.worker_name}` : q}
        onChange={(e) => { onChange(null); setQ(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder="ketik ID atau nama pengepul"
        className="h-11" data-testid="op-worker-input"
      />
      {open && !value && opts.length > 0 && (
        <div className="absolute z-20 mt-1 w-full bg-white border border-slate-200 rounded-lg shadow-lg max-h-60 overflow-y-auto" data-testid="op-worker-options">
          {opts.map((w) => (
            <button key={w.worker_id} type="button" onClick={() => { onChange(w); setOpen(false); setQ(""); }}
              className="w-full text-left px-3 py-2 hover:bg-slate-50 text-sm border-b border-slate-100" data-testid={`op-worker-opt-${w.worker_id}`}>
              <span className="font-mono font-semibold text-blue-700">{w.worker_id}</span> · {w.worker_name}
              <span className="text-[11px] text-slate-400"> · {w.worker_type}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
